import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {setGroheFiltersOpened, setGroheFiltersSearchText} from "../../../../actions/groheFunctions";
import {setSelectedFilters} from "../../../../actions/actionFunctions";
import GroheFiltersValues from "../../grohe/groheNavigation/groheFilters/groheFiltersValues";
import {getCurrentLayout} from "../../../appLayout";
// import {AVAILABLE_FILTERS} from "../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../config";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
// import {COUNTERTOP_GROUP} from "../../../kvComponent/core/constants";
import {getFeatureGroupFilters} from "../../../../misc/filtersFunctions";
import MaterialSpinner from "../../../ui/materialSpinner";
import {getCurrentGroups, getFeatureGroupFromWizardGroup} from "../lookMain/lookWizard/lookWizardFunctions";


const LookFiltersList = (props) => {
  const { className, filtersOpened, intl, isMobile, lookActiveFeature, lookActiveCategory, wizardFeatureGroup,
    isRelatedItemsFilters } = props;
  const [activeFilterId, setActiveFilterId] = useState(null);

  useEffect(() => {
    setActiveFilterId(filtersOpened ? "description" : isMobile ? activeFilterId : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersOpened])

  const handleChange = (filterId, filterName) => (event, isExpanded) => {
    const underscoredText = Analytics.getSkuForAnalytics({dbFeature: {sku: filterName}}, false);
    if (IS_PRODUCT_JOURNEY) {
      Analytics.sendClickEvent(
        isExpanded
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesFiltersAccordionOpen + underscoredText
          : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesFiltersAccordionClose + underscoredText
      );
    } else {
      Analytics.sendClickEvent(
        isExpanded
          ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesFiltersAccordionOpen + underscoredText
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesFiltersAccordionClose + underscoredText
      );
    }

    setActiveFilterId(isExpanded ? filterId : false);
  };

  const layout = getCurrentLayout();
  const featureGroup = wizardFeatureGroup
      || (lookActiveFeature ? lookActiveFeature.getParent() : layout.getFeatureGroupByPartId(lookActiveCategory));

  const availableFilters = filtersOpened && featureGroup && (featureGroup.allFeaturesReceived || isRelatedItemsFilters)
    ? getFeatureGroupFilters(featureGroup)
    : [];

  if (!featureGroup) {
    return null
  }
    // .filter(filterGroup => AVAILABLE_FILTERS.includes(filterGroup.name));

  // if (!featureGroup.filtersReceived) {
  //   return (
  //     <div className={"grohe-filters__list" + (className ? " " + className : "")}
  //          style={{position: "relative", height: "100px"}}>
  //       <MaterialSpinner/>
  //     </div>
  //   )
  // }

  return (
    <div className={"grohe-filters__list" + (className ? " " + className : "")}>
      {availableFilters.map(availableFilter => {
        return (
          <li className="lk-info__list-item" key={availableFilter.id}>
            <Accordion expanded={activeFilterId === availableFilter.id} onChange={handleChange(availableFilter.id, availableFilter.name)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-label={intl.formatMessage({id:"tooltip.editLook"})}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
                className="lk-info__header"
              >
              <div className="grohe-filters__list-item-header">
                <span className="lk-info__header-title bold">
                  {availableFilter.filterGroupName}
                  {availableFilter.selectedFiltersLength ? ` (${availableFilter.selectedFiltersLength})` : null}
                </span>
                {featureGroup.filtersReceived || featureGroup.realFeaturesReceived ? null : <MaterialSpinner size={16}/>}
              </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="lk-info__content">
                  <GroheFiltersValues availableFilter={availableFilter} featureGroup={featureGroup}/>
                </div>
              </AccordionDetails>
            </Accordion>
          </li>
        )
      })}
    </div>
  )
};

LookFiltersList.propTypes = {
  className: PropTypes.string,
  isRelatedItemsFilters: PropTypes.bool
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory} = store.lookState;
  const {isMobile} = store.serverState;
  const {showFilters, selectedFilters, filtersCount} = store.filterState;
  const {filtersOpened} = store.groheState;
  const {featureGroupCount} = store.lookState;

  let wizardFeatureGroup = null
  const {wizardSelectedValues, wizardActiveItem, wizardActiveStep} = store.wizardState;
  if (filtersOpened && wizardActiveItem) {
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (currentGroups.length === 1) {
      wizardFeatureGroup = getFeatureGroupFromWizardGroup(currentGroups[0])
    }
  }

  return {
    filtersOpened: showFilters || filtersOpened,
    filtersCount,
    isMobile,
    // allFilterGroups: filterGroups,
    lookActiveFeature,
    selectedFilters,
    lookActiveCategory,
    featureGroupCount,
    wizardFeatureGroup,
  };
};

const mapDispatchToProps = {
  setGroheFiltersOpened,
  setGroheFiltersSearchText,
  setSelectedFilters,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFiltersList)
);
